import React from 'react';
import { TouchableOpacityProps } from 'react-native';

import arrowRightIcon from '@assets/icons/arrow-right.svg';

import {
  Button,
  ButtonCircle,
  ButtonImage,
  ButtonText,
  Container
} from './styles';

interface RoundedButtonProps extends TouchableOpacityProps {
  label?: string;
  color?: string;
}

const RoundedButton: React.FC<RoundedButtonProps> = ({
  label,
  color,
  ...rest
}) => {
  return (
    <Container>
      <Button {...rest} activeOpacity={0.7}>
        <ButtonCircle color={color}>
          <ButtonImage source={arrowRightIcon} />
        </ButtonCircle>
        <ButtonText color={color}>{label}</ButtonText>
      </Button>
    </Container>
  );
};

export default RoundedButton;
